import script from "./saleInvoiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./saleInvoiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./saleInvoiceDetail.vue?vue&type=style&index=0&id=18cf152e&lang=less"

const __exports__ = script;

export default __exports__